import { useGeneralStore } from "~/stores/general";

export function usePaginationRelLinks(currentPage: number, totalPages: number) {
  const config = useRuntimeConfig();
  const generalStore = useGeneralStore();

  const route = useRoute();
  const router = useRouter();

  const frontDomain = generalStore.bootstrap?.settings?.front_domain;
  const cleanFrontDomain =
    frontDomain && frontDomain?.trim()?.endsWith("/")
      ? frontDomain.slice(0, -1)
      : frontDomain;
  const baseUrl = cleanFrontDomain || config.public.domain || "";

  const nextUrl = computed(() => {
    if (currentPage >= totalPages) {
      return {};
    } else {
      return {
        rel: "next",
        href: `${baseUrl}${router.resolve({ ...route, query: { ...route.query, page: currentPage + 1 } }).fullPath}`,
      };
    }
  });
  const prevUrl = computed(() => {
    if (currentPage <= 1) {
      return {};
    } else {
      return {
        rel: "prev",
        href: `${baseUrl}${router.resolve({ ...route, query: { ...route.query, page: currentPage - 1 } }).fullPath}`,
      };
    }
  });

  const relLinks = computed(() => {
    return [prevUrl.value, nextUrl.value];
  });

  return relLinks;
}
